import { render, staticRenderFns } from "./270c6bd6-6ae2-4220-b1e4-47d6a1f3e299.vue?vue&type=template&id=f50c35a6&scoped=true"
import script from "./270c6bd6-6ae2-4220-b1e4-47d6a1f3e299.vue?vue&type=script&lang=ts"
export * from "./270c6bd6-6ae2-4220-b1e4-47d6a1f3e299.vue?vue&type=script&lang=ts"
import style0 from "./270c6bd6-6ae2-4220-b1e4-47d6a1f3e299.vue?vue&type=style&index=0&id=f50c35a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50c35a6",
  null
  
)

export default component.exports